import { InjectionToken } from '@angular/core';

/**
 * Injection token for the mmscan-api REST base URL.
 *
 * Provide this token in the application config to set the base URL for all
 * mmscan-api REST services:
 *
 * @example
 * ```typescript
 * // app.config.ts
 * import { MMSCAN_API_BASE_URL } from '@mmscan/mmscan-api-angular-client';
 *
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     { provide: MMSCAN_API_BASE_URL, useValue: environment.mmscanApiUrl },
 *   ],
 * };
 * ```
 */
export const MMSCAN_API_BASE_URL = new InjectionToken<string>('MMSCAN_API_BASE_URL');
